import React from 'react'
import StripePowerIcon from './icons/powered-by-stripe'

export default class StripeForm extends React.Component {
  constructor(props) {
    super(props);
    this.cardNumber = elements.create('cardNumber', {style: this.style});
    this.cardExpiry = elements.create('cardExpiry', {style: this.style});
    this.cardCvc = elements.create('cardCvc', {style: this.style});
    this.postalCode = elements.create('postalCode', {style: this.style});
  };

  componentDidMount() {
    if(this.props.brandkitDetails.planType.indexOf('no-cc') < 0) {
      this.mountCard();
      this.addEventListeners();
    }
  }

  get style() {
    return (
      { base: {
        fontSize: '16px',
        lineHeight: '30px',
      }}
    );
  }

  mountCard() {
    this.cardNumber.mount('#card-number-element');
    this.cardExpiry.mount('#card-expiry-element');
    this.cardCvc.mount('#card-cvc-element');
    this.postalCode.mount('#card-postalCode-element');
  }

  addEventListeners() {
    const elementsArr = ['cardNumber', 'cardExpiry', 'cardCvc', 'postalCode'];

    elementsArr.forEach( el => {
      this[el].addEventListener('change', (e) => {
        let displayError = document.getElementById('card-errors');
        displayError.textContent = '';
        if (e.error) {this.displayResult(e.error, displayError)}
      });
    })
  }

  displayResult (error,  displayError) {
    displayError = document.getElementById('card-errors');
    displayError.textContent = error.message;
  }

  submitFormListener(e) {
    e.preventDefault();
    const form = document.getElementById('payment-form');
    this.props.updateOnboarding({paymentStatus: 'Processing'});

    stripe.createToken(this.cardNumber)
      .then( response => {
        if (response.error) {
          this.displayResult(response.error);
          this.props.updateOnboarding({paymentStatus: 'Resubmit Payment'})
          // swal({title: "Error!", text: 'There was an error in the payment process. Please try again or contact support!', type: "error" });
        } else {
          this.props.updateOnboarding({
            stripeToken: response.token,
            creditCardLastFour: response.token['card']['last4'],
            paymentStatus: 'Payment Complete',
            stage: this.props.stage + 1
          });
        }
      });
  }

  skipToBrandkitCreate(e) {
      this.props.updateOnboarding({stage: 4, stripeToken: null});
  }

  setBtnClass() {
    return this.props.paymentStatus === 'Processing' ? 'payment-processing' : '';
  }

  setBtnDisabled() {
    return this.props.paymentStatus === 'Processing';
  }

  setLaterDate() {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + this.setTrialPeriod());
    return `${currentDate.getMonth() + 1}/${currentDate.getDate()}/${currentDate.getFullYear()}`;
  }

  setTrialPeriod() {
    return this.props.brandkitDetails.trialDays;
  }

  get price() {
    return (this.props.brandkitDetails.monthlyPrice / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  }

  render() {
    const {paymentStatus, brandkitDetails} = this.props;

    if (brandkitDetails.planType.indexOf('no-cc') > 0) {
      return (
        <div className='content content--step2-cc-bypass'>
          <h3>Enjoy a {this.setTrialPeriod()}-day trial on us!</h3>
          <button onClick={this.skipToBrandkitCreate.bind(this)} className='dark content--step2__btn'>
            Build your Brandfolder
          </button>
        </div>
      )
    }
    else {
      return (
        <div className='content content--step2'>
          <h3>Enjoy a {this.setTrialPeriod()}-day trial on us!</h3>
          <h3>Your first charge of ${this.price} will process on {this.setLaterDate()}. You can upgrade or cancel at any time.</h3>
          <form onSubmit={this.submitFormListener.bind(this)} id='payment-form'>

            <div className='row'>
                <label className='field field1'>Card Number<div id='card-number-element'></div></label>
            </div>

            <div className='row'>
              <div className='third 1-third'>
                <label className='field field2'>Expires<div id='card-expiry-element'></div></label>
              </div>
              <div className='third 2-third'>
                <label className='field field3'>CVC<div id='card-cvc-element'></div></label>
              </div>

              <div className='third 3-third'>
                <label className='field field4'>Zip Code<div id='card-postalCode-element'></div></label>
              </div>
            </div>

            <div id='card-errors' role='alert'></div>
            <button disabled={this.setBtnDisabled()}
                    className={'dark content--step2__btn ' + this.setBtnClass()}>
              {paymentStatus}
            </button>

          </form>
          <a className='powered-by-stripe content__bot-div' href='https://stripe.com/about' target='_blank'>
            <label><StripePowerIcon /></label>
          </a>
        </div>
      );
    }
  }
}
